import { Settings } from "../generated/api";
import { Configuration } from "../generated/api/runtime";

export function getAPIConfig(settings: Settings) {
  const credentials = settings?.security === "oidc" ? "include" : "omit";
  return new Configuration({
    headers: { "X-XSRF-TOKEN": "" },
    basePath: settings?.serverURL ?? "",
    credentials: credentials,
    middleware: [
      {
        pre: async (r: any) => {
          const { fetch, ...other } = r;
          var csrfToken = "";
          if (document.cookie.includes("XSRF-TOKEN")) {
            var csrfTokenSplit = document.cookie.split("XSRF-TOKEN=");
            csrfToken = csrfTokenSplit[1];
          }

          return {
            ...other,
            init: {
              ...other.init,
              headers: {
                ...other.init.headers,
                "X-XSRF-TOKEN": csrfToken,
              },
            },
          };
        },
      },
    ],
  });
}
